import React from 'react';
import DunningBanner from '../../subscription/components/DunningBanner';
import HipaaSetupBanner from '../../settings/hipaa/HipaaSetupBanner';
import { Features, getFeature } from '../../helpers/PermissionUtility';
import SpecialAccessBanner from './SpecialAccessBanner';
import FeatureFlagBanner from './FeatureFlagBanner';
import { useAppSelector } from '../../hooks/ReduxHooks';
import MaintenanceModeBanner from './MaintenanceModeBanner';

export default function BannerMessage() {
  const maintenanceMode = useAppSelector<boolean>((state) => state.profile?.client?.maintenanceMode);
  const bannerMessage = getFeature(Features.WebBannerMessage, false);

  return (
    <>
      <SpecialAccessBanner />
      <MaintenanceModeBanner shouldShow={maintenanceMode} />
      <FeatureFlagBanner shouldShow={!!bannerMessage && !maintenanceMode} message={bannerMessage} />
      <DunningBanner shouldShow={!bannerMessage && !maintenanceMode} />
      <HipaaSetupBanner shouldShow={!bannerMessage && !maintenanceMode} />
    </>
  );
}
